import { LoadingButton } from "@mui/lab";
import { Button, ButtonGroup, MenuItem, Popover } from "@mui/material";
import { useMultiSelectButton } from "~/hooks/use-multi-select-button";
import ChevronDownIcon from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { usePopover } from "~/hooks/use-popover";
import { FINANCE_REPORT_TYPE } from "~/types/__generated/gql/graphql";
import { FinanceReportModal } from "./finance-report-modal";
import { MoveProcessModal } from "./move-process-modal";
import { MultiSelectMode } from "~/contexts/multi-select-button/multi-select-button-context";
import { FC } from "react";
interface MultiSelectOptions {
  monthlyStatement?: boolean;
  moveProcess?: boolean;
}
export const MultiSelectButton: FC<MultiSelectOptions> = ({
  monthlyStatement,
  moveProcess
}) => {
  const {
    isOpen,
    isCreating,
    mode,
    handleMultiSelectButtonOpen,
    handleMultiSelectButtonClose,
    handleMultiSelectButtonOnCreate
  } = useMultiSelectButton();
  const popover = usePopover<HTMLDivElement>();
  const handleMultiSelectOption = (mode: MultiSelectMode) => {
    handleMultiSelectButtonOpen(mode);
    popover.handleToggle();
  };
  return <>
			{isCreating && mode === MultiSelectMode.FinanceReport && <FinanceReportModal type={FINANCE_REPORT_TYPE.MONTHLY_STATEMENT} />}
			{isCreating && mode === MultiSelectMode.MoveProcess && <MoveProcessModal />}
			<ButtonGroup ref={popover.anchorRef} size="small" variant="contained" data-sentry-element="ButtonGroup" data-sentry-source-file="multi-select-button.tsx">
				<LoadingButton variant="contained" loading={false} disabled={false} onClick={() => {
        if (isOpen && mode) {
          handleMultiSelectButtonOnCreate();
        } else {
          popover.handleToggle();
        }
      }} data-sentry-element="LoadingButton" data-sentry-source-file="multi-select-button.tsx">
					{mode === MultiSelectMode.FinanceReport ? "Create" : mode === MultiSelectMode.MoveProcess ? "Move" : "Multi Select"}
				</LoadingButton>
				<Button disabled={false} size="small" onClick={popover.handleToggle} data-sentry-element="Button" data-sentry-source-file="multi-select-button.tsx">
					<ChevronDownIcon data-sentry-element="ChevronDownIcon" data-sentry-source-file="multi-select-button.tsx" />
				</Button>
			</ButtonGroup>
			<Popover anchorEl={popover.anchorRef.current} disableScrollLock onClose={popover.handleClose} open={popover.open} anchorOrigin={{
      horizontal: "right",
      vertical: "bottom"
    }} transformOrigin={{
      horizontal: "right",
      vertical: "top"
    }} data-sentry-element="Popover" data-sentry-source-file="multi-select-button.tsx">
				{monthlyStatement && <MenuItem key={"create-monthly-statement"} onClick={() => handleMultiSelectOption(MultiSelectMode.FinanceReport)}>
						Monthly Statement
					</MenuItem>}
				{moveProcess && <MenuItem key={"move-process"} onClick={() => handleMultiSelectOption(MultiSelectMode.MoveProcess)}>
						Move Process
					</MenuItem>}
				<MenuItem key={"stop-multi-select"} onClick={() => {
        handleMultiSelectButtonClose();
        popover.handleToggle();
      }} data-sentry-element="MenuItem" data-sentry-source-file="multi-select-button.tsx">
					Stop Multi Select
				</MenuItem>
			</Popover>
		</>;
};